import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  FormControl,
  FormLabel,
  Input,
  Card,
  CardBody,
  useToast,
} from '@chakra-ui/react';

function Login({ onLogin }) {
  const [password, setPassword] = useState('');
  const toast = useToast();

  // Authentication logic
  const ADMIN_PASSWORD = '!FORCENIQUES!'; // Simple password - change this

  const handleLogin = () => {
    if (password === ADMIN_PASSWORD) {
      onLogin(true);
      localStorage.setItem('authenticated', 'true');
      toast({
        title: 'Access granted',
        description: 'Welcome to Forceniques Dashboard',
        status: 'success',
        duration: 2000,
        isClosable: true,
      });
    } else {
      toast({
        title: 'Access denied',
        description: 'Invalid password',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };


  // Check if user is already authenticated on component mount
  useEffect(() => {
    const savedAuth = localStorage.getItem('authenticated');
    if (savedAuth === 'true') {
      onLogin(true);
    }
  }, [onLogin]);

  return (
    <Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
      <Container maxW="md">
        <Card bg="white" borderRadius="lg" boxShadow="xl" border="1px" borderColor="gray.200">
          <CardBody p={8}>
            <VStack spacing={6} align="stretch">
              <VStack spacing={2} align="center">
                <Heading size="lg" color="gray.900" fontWeight="bold">
                  Forceniques
                </Heading>
                <Text color="gray.600" fontSize="sm" textAlign="center">
                  Forensics Power Rangers
                </Text>
              </VStack>
              
              <VStack spacing={4} align="stretch">
                <FormControl>
                  <FormLabel fontSize="sm" color="gray.700" fontWeight="medium">
                    Password
                  </FormLabel>
                  <Input
                    type="password"
                    placeholder="Enter access password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        handleLogin();
                      }
                    }}
                    size="md"
                    bg="white"
                    borderColor="gray.300"
                    color="gray.900"
                    _focus={{ borderColor: "blue.500" }}
                    _placeholder={{ color: "gray.500" }}
                  />
                </FormControl>
                
                <Button
                  colorScheme="blue"
                  size="md"
                  onClick={handleLogin}
                  isDisabled={!password.trim()}
                  _disabled={{ opacity: 0.6, cursor: 'not-allowed' }}
                >
                  Access Dashboard
                </Button>
              </VStack>
            </VStack>
          </CardBody>
        </Card>
      </Container>
    </Box>
  );
}

export default Login;
